export default "__VITE_ASSET__uP01ODGU__"